import { useWindowSize } from './useWindowSize';

const useIsMobile = () => {
  const { width } = useWindowSize();

  return {
    isMobile: width && width < 768,
    isTablet: width && width < 1024,
  };
};

export { useIsMobile };
